module.exports = __webpack_public_path__ + "static/media/估值挖掘机@2x.f2a20652.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/估值挖掘机@2x.png
// module id = 1575
// module chunks = 0